module.exports = __webpack_public_path__ + "img/LaBase-Sorrento-Vege-Burger-600px.b81c9d22.jpg";